import { Component, inject, OnInit } from '@angular/core'
import { ActivatedRoute, ParamMap } from '@angular/router'
import { switchMap } from 'rxjs/operators'
import HttpError from '@ui/HttpError'
import Guest from '@client/Guest'
import { GuestService } from '@client/Services/GuestService'
import { Location } from '@angular/common'
import { CardComponent } from '@ui/Components/Card/Card.Component'
import { CardContentComponent } from '@ui/Components/Card/CardContent.Component'
import { RaisedButtonComponent } from '@ui/Components/Form/Button/RaisedButton.Component'
import { GuestFormComponent } from '@client/Components/Guests/Form/GuestForm.Component'
import { PageComponent } from '@client/Components/ui/Page/Page.Component'

@Component({
	selector: 'guest-component',
	templateUrl: './Guest.Component.html',
	imports: [
		CardComponent,
		CardContentComponent,
		RaisedButtonComponent,
		GuestFormComponent,
		PageComponent,
	],
})
export class GuestComponent implements OnInit {
	protected guest: Guest

	private readonly activatedRoute: ActivatedRoute

	private readonly guestService: GuestService

	private readonly location: Location

	constructor() {
		this.activatedRoute = inject(ActivatedRoute)
		this.guestService = inject(GuestService)
		this.location = inject(Location)
	}

	public ngOnInit() {
		this.activatedRoute.paramMap
			.pipe(
				switchMap(async (params: ParamMap) => {
					try {
						return await this.guestService.find(parseInt(params.get('id'), 10))
					} catch (error) {
						if (!(error instanceof HttpError)) {
							throw error
						}
					}
				}),
			)
			.subscribe((guest: Guest) => {
				if (guest) {
					this.guest = guest
				}
			})
	}

	public back = (): void => {
		this.location.back()
	}

	public readonly updateGuest = async (guest: Guest): Promise<void> => {
		this.guest = await this.guestService.updateGuest(guest)
	}
}
